module.exports = __webpack_public_path__ + "img/retrofit-details-4.4336668c.png";